export class UpdateSamlIdentityProviderInput {
    'ssoUrl';
    'logoutUrl';
    'issuerUrl';
    'certificate';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "ssoUrl",
            "baseName": "ssoUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "logoutUrl",
            "baseName": "logoutUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "issuerUrl",
            "baseName": "issuerUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "certificate",
            "baseName": "certificate",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateSamlIdentityProviderInput.attributeTypeMap;
    }
    constructor() {
    }
}
